import { render } from "./GalleryIndex.vue?vue&type=template&id=23b6505d"
import script from "./GalleryIndex.vue?vue&type=script&lang=js"
export * from "./GalleryIndex.vue?vue&type=script&lang=js"
script.render = render

export default script